<template>
  <div class="form-container">
    <!-- 电脑端使用 Element UI 表单 -->
    <section v-if="isDesktop" style="padding:0 5%;">
      <el-container style="height: 100%;">
        <el-aside width="200px" style="height:100%">
          <el-form
          ref="form"
          label-position="top"
          status-icon
          :model="form"
          :rules="rules"
          label-width="100px"
          style="width:100%;"
          >
            <el-form-item label="权限标识" prop="permission_id" required>
              <el-input v-model="form.permission_id" placeholder="请输入菜单项的ID,不可重复"></el-input>
            </el-form-item>

            <el-form-item label="权限名称" prop="permission_name" required>
              <el-input v-model="form.permission_name" placeholder="请输入菜单名称"></el-input>
            </el-form-item>

            <el-form-item label="备注" prop="comment">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入备注"
                v-model="form.comment">
              </el-input>
            </el-form-item>

            <el-form-item>
              <el-button @click="close">取消</el-button>
              <el-button type="primary" @click="submit('form')" :plain="true">立即添加</el-button>
            </el-form-item>
          </el-form>
        </el-aside>
        <el-container style=" height:calc(100vh - 90px);"> 
          <el-main style="margin-left: 20px;border-left:1px solid rgba(0,0,0,0.1)" v-if="permission_select">
              <div v-for="(value,key) in menus">
                <div style="width:100%" v-if="value.parent_id === 0">
                  <div style="font-weight:bolder;font-size: 20px;">{{value.name}}
                    <el-checkbox style="margin-left:10px;" v-if="value.handle_arr.length>0" :indeterminate="permission_select[value.menu_id] && permission_select[value.menu_id].length === value.handle_arr.length" @change="handleCheckAllChange($event,value.menu_id,value.handle_arr)">全选</el-checkbox>
                  </div>
                  <div style="font-size:12px;">{{value.comment}}</div>
                  <div style="width:100%;display:inline-flex;margin-top:16px;margin-bottom:20px;" v-if="value.handle_arr.length>0">
                    
                    <el-checkbox-group v-model="permission_select[value.menu_id]" @change="handleCheckedpermissionsChange($event,value.menu_id)">
                      <el-checkbox 
                      v-for="(v,k) in value.handle_arr" 
                      :label="v" :key="value.menu_id+v" 
                      >
                        <span v-if="v==='look'">查看/搜索数据</span>
                        <span v-if="v==='add'">增加数据</span>
                        <span v-if="v==='update'">更改数据</span>
                        <span v-if="v==='deleted'">删除/拉黑数据</span>
                        <span v-if="v==='examine'">审核权限</span>
                      </el-checkbox>
                    </el-checkbox-group>
                     
                  </div>
                </div>
                <div style="width:100%;margin-top:10px;margin-left:20px;" v-if="value.parent_id > 0">
                  <div style="font-weight:bolder;font-size: 16px;">
                    {{value.name}}
                    <el-checkbox style="margin-left:10px;" v-if="value.handle_arr.length>0" :indeterminate="permission_select[value.menu_id] && permission_select[value.menu_id].length === value.handle_arr.length" @change="handleCheckAllChange($event,value.menu_id,value.handle_arr)">全选</el-checkbox>
                  </div>
                  <div style="font-size:12px;">{{value.comment}}</div>
                  <div style="width:100%;display:inline-flex;margin-top:16px;margin-bottom:20px;" v-if="value.handle_arr.length>0">
                    <el-checkbox-group v-model="permission_select[value.menu_id]"  @change="handleCheckedpermissionsChange($event,value.menu_id)">
                      <el-checkbox v-for="(v,k) in value.handle_arr" :label="v" :key="value.menu_id+v">
                        <span v-if="v==='look'">查看/搜索数据</span>
                        <span v-if="v==='add'">增加数据</span>
                        <span v-if="v==='update'">更改数据</span>
                        <span v-if="v==='deleted'">删除/拉黑数据</span>
                        <span v-if="v==='examine'">审核权限</span>
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
              </div>
          </el-main>
        </el-container>
      </el-container>
    </section>

    <!-- 手机端使用 Vant 表单 -->
    <div v-else class="mobile-form-container">
      <div class="mobile-form-content">
        <van-form ref="mobileForm" :model="form" :rules="rules" @submit="onMobileSubmit">
          <!-- 基本信息 -->
          <van-cell-group inset>
            <!-- 权限标识 -->
            <van-field
              v-model="form.permission_id"
              name="permission_id"
              label="权限标识"
              input-align="right"
              placeholder="请输入菜单项的ID,不可重复"
              :validate-trigger="['onChange', 'onBlur']"
            />
            
            <!-- 权限名称 -->
            <van-field
              v-model="form.permission_name"
              name="permission_name"
              label="权限名称"
              input-align="right"
              placeholder="请输入菜单名称"
              :validate-trigger="['onChange', 'onBlur']"
            />
            
            <!-- 备注 -->
            <van-field
              v-model="form.comment"
              name="comment"
              label="备注"
              type="textarea"
              rows="2"
              input-align="right"
              placeholder="请输入备注"
              :validate-trigger="['onChange', 'onBlur']"
            />
          </van-cell-group>
          
          <!-- 权限菜单选择 -->
          <div class="mobile-permission-section">
            <h3 class="section-title">权限菜单配置</h3>
            <div v-for="(value, key) in menus" :key="key" class="mobile-menu-item">
              <!-- 一级菜单 -->
              <div v-if="value.parent_id === 0" class="menu-level-1">
                <div class="menu-header">
                  <h4 class="menu-name">{{ value.name }}</h4>
                  <div v-if="value.handle_arr && value.handle_arr.length > 0" class="menu-actions">
                    <van-button 
                      size="small" 
                      type="default" 
                      plain
                      @click="toggleAllPermissions(value.menu_id, value.handle_arr)"
                    >
                      {{ isAllSelected(value.menu_id, value.handle_arr) ? '取消全选' : '全选' }}
                    </van-button>
                  </div>
                </div>
                <div class="menu-comment">{{ value.comment }}</div>
                <div v-if="value.handle_arr && value.handle_arr.length > 0" class="menu-permissions">
                  <van-cell-group inset>
                    <van-cell 
                      v-for="(v, k) in value.handle_arr" 
                      :key="value.menu_id + v" 
                      :title="getPermissionText(v)" 
                      is-link
                      @click="togglePermission(value.menu_id, v)"
                    >
                      <template #right-icon>
                        <van-icon name="success" color="#07c160" v-if="isPermissionSelected(value.menu_id, v)" />
                      </template>
                    </van-cell>
                  </van-cell-group>
                </div>
              </div>
              
              <!-- 二级菜单 -->
              <div v-else class="menu-level-2">
                <div class="menu-header">
                  <h4 class="menu-name">{{ value.name }}</h4>
                  <div v-if="value.handle_arr && value.handle_arr.length > 0" class="menu-actions">
                    <van-button 
                      size="small" 
                      type="default" 
                      plain
                      @click="toggleAllPermissions(value.menu_id, value.handle_arr)"
                    >
                      {{ isAllSelected(value.menu_id, value.handle_arr) ? '取消全选' : '全选' }}
                    </van-button>
                  </div>
                </div>
                <div class="menu-comment">{{ value.comment }}</div>
                <div v-if="value.handle_arr && value.handle_arr.length > 0" class="menu-permissions">
                  <van-cell-group inset>
                    <van-cell 
                      v-for="(v, k) in value.handle_arr" 
                      :key="value.menu_id + v" 
                      :title="getPermissionText(v)" 
                      is-link
                      @click="togglePermission(value.menu_id, v)"
                    >
                      <template #right-icon>
                        <van-icon name="success" color="#07c160" v-if="isPermissionSelected(value.menu_id, v)" />
                      </template>
                    </van-cell>
                  </van-cell-group>
                </div>
              </div>
            </div>
          </div>
        </van-form>
      </div>
      
      <!-- 手机端固定底部按钮 -->
      <div class="mobile-form-actions">
        <van-button type="default" block @click="close">取消</van-button>
        <van-button type="primary" block @click="onMobileSubmit">立即添加</van-button>
      </div>
    </div>
  </div>
</template>

<script>
  let _this;
  import {addPermission,getMenus} from "@/api/system.js";
  import { Field, Cell, CellGroup, Button, Form, Toast, Icon } from 'vant';
  
  let form = {
          permission_id: "",
          permission_name: "",
          comment: '',
          permission_menu:[],
        }
  export default {
    components: {
      [Field.name]: Field,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Button.name]: Button,
      [Form.name]: Form,
      [Icon.name]: Icon
    },
    
    data() {
      return {
        isDesktop: true,
        form: form,
        menus:[],
        permission_select:[],
        rules: {
          permission_id: [
            {required: true, message: "请输入权限标识,不可重复", trigger: "blur"},
          ],
          permission_name: [
            {required: true, message: "请输入权限名称", trigger: "blur"},
          ]
        },
      };
    },

    computed: {},

    mounted() {
      _this = this;
      _this.init();
      this.checkScreenSize();
      window.addEventListener('resize', this.handleResize);
    },
    
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
    },

    methods: {
      // 检查屏幕大小
      checkScreenSize() {
        this.isDesktop = window.innerWidth > 768;
      },
      
      // 处理窗口大小变化
      handleResize() {
        this.checkScreenSize();
      },
      
      // 初始化数据
      init() {
        getMenus().then(res=>{
          if(res.code === 200){
            this.menus = res.data
            let permission = {}
            res.data.forEach((value,key) => {
              if(value.handle_arr && value.handle_arr.length>0){
                permission[value['menu_id']] = []
              }
            });
            this.permission_select = permission
          }
        })
      },

      handleCheckAllChange(event,menu_id,arr){
        arr = JSON.parse(JSON.stringify(arr))
        this.permission_select[menu_id] = []
        if(event){
          this.permission_select[menu_id] = arr
        }
        this.$nextTick(function () {
          this.$forceUpdate()
        })
      },

      handleCheckedpermissionsChange(event,menu_id){
        this.$nextTick(function () {
          this.$forceUpdate()
        })
      },
      
      // 手机端：获取权限文本
      getPermissionText(permission) {
        switch (permission) {
          case 'look': return '查看/搜索数据';
          case 'add': return '增加数据';
          case 'update': return '更改数据';
          case 'deleted': return '删除/拉黑数据';
          case 'examine': return '审核权限';
          default: return permission;
        }
      },
      
      // 手机端：判断是否选中所有权限
      isAllSelected(menuId, permissions) {
        if (!this.permission_select[menuId]) {
          return false;
        }
        return this.permission_select[menuId].length === permissions.length;
      },
      
      // 手机端：判断是否选中某个权限
      isPermissionSelected(menuId, permission) {
        if (!this.permission_select[menuId]) {
          return false;
        }
        return this.permission_select[menuId].includes(permission);
      },
      
      // 手机端：切换单个权限
      togglePermission(menuId, permission) {
        if (!this.permission_select[menuId]) {
          this.permission_select[menuId] = [];
        }
        
        const index = this.permission_select[menuId].indexOf(permission);
        if (index > -1) {
          this.permission_select[menuId].splice(index, 1);
        } else {
          this.permission_select[menuId].push(permission);
        }
      },
      
      // 手机端：切换全选/取消全选
      toggleAllPermissions(menuId, permissions) {
        if (this.isAllSelected(menuId, permissions)) {
          this.permission_select[menuId] = [];
        } else {
          this.permission_select[menuId] = JSON.parse(JSON.stringify(permissions));
        }
      },
     
      close() {
        _this.$emit("close");
      },
      
      // 电脑端提交
      submit(form) {
        this.$refs[form].validate(valid => {
          if (valid) {
            let data = _this.form
            data['permission_menu'] = JSON.parse(JSON.stringify(this.permission_select))
            addPermission(data).then(res => { 
              if (res.code === 200) {
                _this.$message({
                  message: "添加成功",
                  type: "success"
                });
                this.form = JSON.parse(JSON.stringify(form));
                setTimeout(() => {
                  _this.$emit("success");
                }, 1000);
              }
            })
          } else {
            return false;
          }
        })
      },
      
      // 手机端提交
      onMobileSubmit() {
        this.$refs.mobileForm.validate().then(() => {
          let data = _this.form;
          data['permission_menu'] = JSON.parse(JSON.stringify(this.permission_select));
          addPermission(data).then(res => {
            if (res.code === 200) {
              Toast({
                message: '添加成功',
                type: 'success',
                duration: 1500
              });
              setTimeout(() => {
                _this.$emit("success");
                _this.$emit("close");
              }, 1500);
            }
          });
        }).catch(errorInfo => {
          console.log('表单验证失败：', errorInfo);
        });
      }
    }
  };
</script>
<style lang="scss" scoped>
  .form-container {
    width: 100%;
    height: 100%;
  }

  .avatar-uploader .el-upload {
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    border: 1px dashed #ccc;
    border-radius: 50%;
    overflow: hidden;
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-radio-group {
    text-align: left !important;
  }

  .icon-dialog{
    width: 100%;
    display:flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .icon-dialog-list{
      box-sizing: border-box;
      padding: 20px 10px;
      width: 16.66%;
      font-size: 32px;
      text-align: center;
      border:1px solid #dbdbdb;
    }
    .icon-dialog-list:hover{
      color:#409eff;
      border-color:#409eff;
    }
  }
  .icon-name{
    margin-top:10px;
    font-size: 12px;
  }
  
  // 手机端样式
  .mobile-form-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .mobile-form-content {
    flex: 1;
    overflow-y: auto;
    padding-bottom: 45px;
  }

  .mobile-form-actions {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    z-index: 100;
  }

  .mobile-form-actions .van-button {
    flex: 1;
    height: 44px;
    font-size: 16px;
  }
  
  // 手机端权限配置区域样式
  .mobile-permission-section {
    margin-top: 20px;
    padding: 0 15px;
  }
  
  .section-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 15px;
    color: var(--text);
  }
  
  .mobile-menu-item {
    margin-bottom: 20px;
  }
  
  .menu-level-1 {
    background-color: var(--bg-100);
    border-radius: var(--border-radius);
    overflow: hidden;
    box-shadow: var(--shadow-sm);
  }
  
  .menu-level-2 {
    background-color: var(--bg-200);
    border-radius: var(--border-radius);
    overflow: hidden;
    margin-left: 15px;
    box-shadow: var(--shadow-sm);
  }
  
  .menu-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background-color: var(--background);
  }
  
  .menu-name {
    font-size: 16px;
    font-weight: 600;
    margin: 0;
    color: var(--text);
  }
  
  .menu-comment {
    padding: 0 15px 10px;
    font-size: 14px;
    color: var(--text-200);
  }
  
  .menu-permissions {
    margin-top: 10px;
    padding: 0 15px 15px;
  }
  
  .menu-actions {
    display: flex;
    gap: 10px;
  }
  
  .menu-actions .van-button {
    font-size: 12px;
    height: 28px;
    padding: 0 10px;
  }
</style>
<style>
  .el-dialog__body{
    max-height: 60vh;
    overflow-y: auto;
  }
</style>
